<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  created() {
    let _ = this;
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      // Stash the event so it can be triggered later.
      if (_.$pwa.pwaRsp.prompt !== false) _.$pwa.pwaRsp.prompt = e;
    });
    window.addEventListener("appinstalled", () => {
      _.$pwa.pwaRsp.prompt = false;
    });
  },
  methods: {

  }
}
</script>
